/**
 * The display preferences on screen (DNA: density rapat or biasa, the three-step text size,
 * "Kurangi gerakan"), bound to the html attributes index.html sets before React mounts.
 * `terapkan` rewrites them at once (tables re-densify through `--row-h`, the rems re-scale
 * through the root font size, the motion tokens collapse). What is stored, and whose, is the
 * account's (./preferensi, plan 9b): the store starts from the copy index.html applied (the
 * last person's on this device) and shows whatever a sign-in, an unlock or Akun hands it.
 * `useDensity` (primitives) and `useReducedMotion` (app/motion) observe the attributes.
 */
import { create } from 'zustand'
import {
  browserStorage,
  type RootLike,
  type Tampilan,
  tampilanAwal,
  terapkanTampilan,
} from './tampilan'

export type { Kepadatan, PilihanGerakan, Tampilan, UkuranTeks } from './tampilan'
export { KEPADATAN, UKURAN_TEKS } from './tampilan'

function browserRoot(): RootLike | null {
  return typeof document === 'undefined' ? null : document.documentElement
}

function osReduce(): boolean {
  return typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches
}

export interface DeviceState extends Tampilan {
  /** Shows a preference: the state and the three html attributes. Stores nothing. */
  terapkan(pref: Tampilan): void
}

export const useDevice = create<DeviceState>()((set) => ({
  ...tampilanAwal(browserStorage(), browserRoot()),
  terapkan: (pref) => {
    set({ density: pref.density, text: pref.text, motion: pref.motion })
    const root = browserRoot()
    if (root !== null) terapkanTampilan(root, pref, osReduce())
  },
}))

// When the OS preference changes while the app is open, re-apply with the current
// choice (index.html's listener re-reads the stored key for the same reason).
if (typeof matchMedia === 'function') {
  matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', () => {
    const root = browserRoot()
    if (root !== null) terapkanTampilan(root, useDevice.getState(), osReduce())
  })
}
